window.addEventListener('load', () => {
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.accordion__btn');
    if (!btn) return;

    btn.closest('.accordion__item').classList.toggle('open');
  });
});
